
namespace TabAurous.Sales {
  /*  export class RFMAnalysisOptions {
        items: POSSalesItemsRow[];
    }

    export class RFMAnalysisPanel extends Serenity.TemplatedPanel<RFMAnalysisOptions> {
        constructor(container: JQuery, opt: RFMAnalysisOptions) {
            super(container, opt);
            

            //Grouping
            var items = this.options.items;

            var name= 'P1';
             var data= [1,2,3];
            
            var namearray = [name];
            var dataarray = [data];
            namearray.pop();
            dataarray.pop();
            for (var i = 0; i < items.length; i++) {
                var exists = false;
                for (var k = 0; k < namearray.length; k++) {
                    if (items[i].CategoryName == namearray[k]) {
                        dataarray[k][0] += items[i].M1Pieces;
                        dataarray[k][1] += items[i].M2Pieces;
                        dataarray[k][2] += items[i].M3Pieces;
                        dataarray[k][3] += items[i].M4Pieces;
                        dataarray[k][4] += items[i].M5Pieces;
                        dataarray[k][5] += items[i].M6Pieces;
                        dataarray[k][6] += items[i].M7Pieces;
                        dataarray[k][7] += items[i].M8Pieces;
                        dataarray[k][8] += items[i].M9Pieces;
                        dataarray[k][9] += items[i].M10Pieces;
                        dataarray[k][10] += items[i].M11Pieces;
                        dataarray[k][11] += items[i].M12Pieces;
                        exists = true;
                    }
                }
                if (!exists) {
                    namearray.push(items[i].CategoryName);
                    var newdata = [items[i].M1Pieces, items[i].M2Pieces, items[i].M3Pieces, items[i].M4Pieces, items[i].M5Pieces, items[i].M6Pieces,
                        items[i].M7Pieces, items[i].M8Pieces, items[i].M9Pieces, items[i].M10Pieces, items[i].M11Pieces, items[i].M12Pieces];
                    dataarray.push(newdata);
                }
            }
            var ser = [{ name, data }];
            ser.pop();
            for (var i = 0; i < namearray.length; i++) {
                name = namearray[i];
                data = dataarray[i];
                var newseries = { name, data };
                ser.push(newseries);
            }

            var options = {
                series: ser,
                chart: {
                    fontFamily: '"PT Sans", sans-serif',
                    type: 'bar',
                    height: 250,
                    stacked: true,
                    toolbar: {
                        show: true
                    },
                    zoom: {
                        enabled: true
                    }
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        legend: {
                            position: 'bottom',
                            offsetX: -10,
                            offsetY: 0
                        }
                    }
                }],
                plotOptions: {
                    bar: {
                        horizontal: false,
                    },
                },
                xaxis: {
                   
                    categories: ['January','February','March','April','May','June','July','August','September','October','November','December'
                    ],
                },
                legend: {
                    position: 'right',
                    offsetY: 40
                },
                fill: {
                    opacity: 1
                }
            };




            //var x = document.getElementById('TabAurous_Reports_ChartPanel13_chartContainer');
            var y = container[0].childNodes[0];
            var chart = new ApexCharts(y, options);

            chart.render();
        }

        getTemplate() {

            return `<div id="~_chartContainer"></div>`;
        }
    }
*/


    @Serenity.Decorators.registerClass()
    export class RFMAnalysisGrid extends Serenity.EntityGrid<SalesMasterRow, any> {
        protected getColumnsKey() { return 'Sales.RFMAnalysis'; }
        protected getDialogType() { return SalesMasterDialog; }
        protected getIdProperty() { return SalesMasterRow.idProperty; }
        protected getInsertPermission() { return SalesMasterRow.insertPermission; }
        protected getLocalTextPrefix() { return SalesMasterRow.localTextPrefix; }
        protected getService() { return RFMAnalysisService.baseUrl; }
       // private chartContainer: JQuery;
     //   private chartPanel: RFMAnalysisPanel;
        constructor(container: JQuery) {
            super(container);
            this.setTitle("");
            //  this.addDateRangeFilter("TransDate", "Date");
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            this.view.setSummaryOptions({
                aggregators: [
                    new Slick.Aggregators.Sum('TotalSales')]
            });


            this.view.setGrouping([{
               
                getter: 'CustomerType',
                displayTotalsRow: false,
                
            }])

            return grid;
        }

        //protected getSlickOptions() {
        //    var opt = super.getSlickOptions();
        //    opt.showFooterRow = true;
        //    return opt;
        //}
      
        //onViewProcessData(response: Serenity.ListResponse<POSSalesItemsRow>) {

        //    if (!this.chartContainer) {
        //        this.chartContainer = $("<div style='padding: 20px 0' />");
        //        this.chartContainer.insertBefore(this.element.find(".grid-container"));
        //    }

        //    if (this.chartPanel) {
        //        this.chartPanel.destroy();
        //    }

        //    this.chartPanel = new RFMAnalysisPanel(this.chartContainer, { items: response.Entities });

        //    //var options = {
        //    //    chart: {
        //    //        type: 'bar'
        //    //    },
        //    //    series: [
        //    //        {
        //    //            name: 'sales',
        //    //            data: [30, 40, 35, 50, 49, 60, 70, 91, 125]
        //    //        }
        //    //    ],
        //    //    xaxis: {
        //    //        categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999]
        //    //    }
        //    //}

        //    //var chart = new ApexCharts(document.querySelector(".chartContainer"), options);

        //    //chart.render();


        //    return response;
        //}
        protected usePager(){ return false;}
        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            buttons.push({

                title: 'Print',
                icon: 'fa fa-print text-blue',
                //icon: 'fa-cloud-download',
                onClick: () => {

                    Common.ReportHelper.execute({
                        reportKey: 'Reports.ApprovalRegister',
                        params: {
                            CompanyIds: this.view.params.CompanyIds,
                            FinIds: this.view.params.FinancialYearIds,
                            VendorIds: this.view.params.VendorIds,
                            date: this.view.params.Criteria
                        }
                    });
                }
            });
            return buttons;
        }

    }
}